import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../ui/SectionHeading';

const Step = ({ title, desc, number, isLast }) => (
  <div className="relative flex-1 text-center px-4">
    <motion.div 
      initial={{ scale: 0 }}
      whileInView={{ scale: 1 }}
      viewport={{ once: true }}
      className="w-20 h-20 mx-auto bg-gradient-to-br from-royal-500 to-royal-700 rounded-2xl flex items-center justify-center text-3xl font-bold text-white shadow-lg shadow-royal-500/30 mb-6 relative z-10 rotate-3"
    >
      <div className="absolute inset-0 bg-white/20 rounded-2xl -rotate-6 transition-transform group-hover:rotate-0"></div>
      {number}
    </motion.div>
    {!isLast && (
      <div className="hidden lg:block absolute top-10 left-[60%] w-full h-[2px] bg-gradient-to-r from-royal-500/50 to-transparent z-0"></div>
    )}
    <h4 className="text-xl font-bold text-white mb-2">{title}</h4>
    <p className="text-gray-400">{desc}</p>
  </div>
);

export const ChallengeSystem = () => {
  return (
    <section className="py-24 px-4 bg-navy-900 border-y border-white/5">
      <div className="max-w-6xl mx-auto">
        <SectionHeading subtitle="A proven roadmap designed to take you from zero to scale without the overwhelm.">
          3 Step Execution System
        </SectionHeading>

        <div className="flex flex-col lg:flex-row gap-12 lg:gap-4 mt-16">
          <Step number="1" title="3 Day Challenge" desc="Build your business foundation" />
          <Step number="2" title="30 Day Challenge" desc="Build your ₹1L/month system" />
          <Step number="3" title="90 Day Challenge" desc="Scale your system for massive growth" isLast={true} />
        </div>
      </div>
    </section>
  );
};